import { render, staticRenderFns } from "./StatusMandatoForm.vue?vue&type=template&id=74851e7a&scoped=true&"
import script from "./StatusMandatoForm.vue?vue&type=script&lang=js&"
export * from "./StatusMandatoForm.vue?vue&type=script&lang=js&"
import style0 from "./StatusMandatoForm.vue?vue&type=style&index=0&id=74851e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74851e7a",
  null
  
)

export default component.exports